import React from 'react';
import CalendarBlankIcon from '@/components/icons/CalendarBlankIcon/CalendarBlankIcon';
import SignpostIcon from '@/components/icons/SignpostIcon/SignpostIcon';
import AirplaneIcon from '@/components/icons/AirplaneIcon/AirplaneIcon';
import CalendarXIcon from '@/components/icons/CalendarXIcon/CalendarXIcon';
import AirplaneTakeoffIcon from '@/components/icons/AirplaneTakeoffIcon/AirplaneTakeoffIcon';
import CoffeIcon from '@/components/icons/CoffeIcon/CoffeIcon';
import { ListItem, UnorderedList } from './TravelDetailList.styles';
import BarcodeIcon from '@/components/icons/BarcodeIcon/BarcodeIcon';
import dayjs from 'dayjs';
import { useTranslations } from 'next-intl';

type TravelDetailListProps = PacoteItinerarySimilarType & {
  travel_cities?: string;
  travel_meal?: string;
  reference?: number;
};

const TravelDetailList = ({ ...props }: TravelDetailListProps) => {
  const t = useTranslations('Pacote');
  const { travel_duration, travel_flight, travel_cities, travel_meal, expired_at, travel_departure, reference } = props;
  return (
    <UnorderedList>
      <ListItem>
        <CalendarBlankIcon />
        <span>
          {t('Duração')}: <strong>{travel_duration}</strong>
        </span>
      </ListItem>
      {(travel_cities && (
        <ListItem>
          <SignpostIcon />
          <span>
            {travel_cities?.includes(',') ? t('Destinos') : t('Destino')} :{' '}
            <strong title={travel_cities}>{travel_cities}</strong>
          </span>
        </ListItem>
      )) ||
        null}
      <ListItem>
        <AirplaneIcon />
        <span>
          {t('Passagem Aérea')}: <strong>{travel_flight}</strong>
        </span>
      </ListItem>
      <ListItem>
        <CalendarXIcon />
        <span>
          {t('Validade')}: <strong>{(expired_at && dayjs(expired_at).format('DD/MM/YYYY')) || '--'}</strong>
        </span>
      </ListItem>
      <ListItem>
        <AirplaneTakeoffIcon />
        <span>
          {t('Saídas')}: <strong>{travel_departure}</strong>
        </span>
      </ListItem>
      {(travel_meal && travel_meal?.length > 1 && (
        <ListItem>
          <CoffeIcon />
          <span>
            {t('Plano de Refeição')}: <strong>{travel_meal}</strong>
          </span>
        </ListItem>
      )) ||
        null}

      {(reference && (
        <ListItem>
          <BarcodeIcon />
          <span>
            {t('Número de Referência')}: <strong>{reference}</strong>
          </span>
        </ListItem>
      )) ||
        null}
    </UnorderedList>
  );
};

export default TravelDetailList;
